import {
  Section,
  ContentBlock,
  TextBlock,
  Font,
} from '@politechdev/blocks-design-system'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { useCurrentFlagContext } from './contexts/CurrentFlagContext'
import styles from './FlagSingleCanvasserDetail.module.scss'

const FlagSingleCanvasserDetail = () => {
  const { t } = useTranslation()

  const { currentFlag } = useCurrentFlagContext()

  const { canvasser, turf } = currentFlag || {}

  return (
    <Section label={t('Canvasser')}>
      <ContentBlock>
        <Link to={`/collect/voter_registration/canvassers/${canvasser?.id}`}>
          <Font.Display className={styles.name}>
            {canvasser?.full_name}
          </Font.Display>
        </Link>
      </ContentBlock>
      <TextBlock>
        <Font.Label>Turf</Font.Label>
        <Font.Copy>{turf?.name}</Font.Copy>
      </TextBlock>
    </Section>
  )
}

export default FlagSingleCanvasserDetail
